import { useEffect, useContext} from "react";
import { OaRVaRChartConfig } from "./OaRVaRChartConfig";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { Loader } from "../../../components/loader/Loader";

export const VaRChart = () => {
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);

  const { oarvar, filter, varFiltered } = lstore;

  useEffect(() => {
    if (oarvar && oarvar.rawdata.length > 0) {       

      const fdata = oarvar.rawdata
        .filter((row) => {
          return (
            filter["ModelDate"].includes(row["ModelDate"]) &&
            filter["Ticker"].includes(row["Ticker"]) &&
            filter["Horizon"].includes(row["Horizon"]) &&
            filter["RiskModel"].includes(row["RiskModel"]) &&
            filter[" Pctile "].includes(row[" Pctile "]) &&
            row["VaR"]
          );
        })
        .map((item) => {
          return {
            ...item,
            "V-Score": +item["V-Score"],
            VaR:
              item["RiskModel"] === "Sigma"
                ? +item["VaR"].split("%").join("") 
                : +item["VaR"].split("%").join(""),
          };
        });

      ldispatch({ type: lactionTypes.SET_VaR_FILTERED, payload: fdata });
    }
  }, [
    oarvar,
    ldispatch,
    filter,
  ]);

  return varFiltered ? (
    <OaRVaRChartConfig
      data={varFiltered}
      width={refs.componentSize.current["VaRChart"].width}
      height={refs.componentSize.current["VaRChart"].height}
      lRef={refs.varx}
      palette={refs.tickerPalette.current}
      selection="VaR"
    />
  ) : (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader />
    </div>
  );
};
